// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"375":"repo","414":"image","529":"package","543":"data","746":"catalogue","878":"generic"}[chunkId] + "." + {"375":"025c2cf2","414":"2b04c80d","529":"eaa19a73","543":"a3676177","746":"67d242bb","878":"8923f03b"}[chunkId] + ".js";
};